// import external dependencies
import 'jquery';

// Require/Import vendors
require('./vendors/jquery.txtTruncate');
require('../../../node_modules/flickity/dist/flickity.pkgd');
require('./vendors/flickity-fullscreen');
require('./vendors/hammer');

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import LazyLoad from 'vanilla-lazyload';
// import SimpleBar from "simplebar";


// console.log(SimpleBar);


// Require Components
require('./components/nav.js');
require('./components/related_products');
require('./components/featured_article');
require('./components/accordion');
require('./components/cookie');
require('./components/form-ui');
require('./components/flickFix');
require('./components/product-listing');
require('./components/single-product');
require('./util/crossPlatform');
require('./components/hero');
require('./components/video');
require('./components/health_panel');
require('./components/map');
require('./components/selected-country-hero-banner');
require('./components/menu');
require('./components/campaign');
require('./components/campaign-button');
require('./components/campaign-text-50');
// require('./components/modal');
// require('./components/timeline');

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
// jQuery(document).ready(() => routes.loadEvents());

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();

  // new SimpleBar(document.getElementById('js-scrollbar'));

  let lazyLoadInstance = new LazyLoad({
    threshold: 500,
    elements_selector: '.lazy',
  });

  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }

  window.lazyLoadInstance = lazyLoadInstance;

});



// WEBPACK FOOTER //
// ./scripts/main.js